// action types
export const API_CALL_REQUEST = 'API_CALL_REQUEST';
export const API_CALL_SUCCESS = 'API_CALL_SUCCESS';
export const API_CALL_FAILURE = 'API_CALL_FAILURE';

// Player
export const ADD_CONTENT_ID = 'ADD_CONTENT_ID';

export const IS_AUTHENTICATED = 'IS_AUTHENTICATED';
export const IS_AUTHORIZED = 'IS_AUTHORIZED';

// URL
export const SET_LMS_URL = 'SET_LMS_URL';
export const SET_SESSION_ID = 'SET_SESSION_ID';
export const SET_CONTENT_PARAMS = 'SET_CONTENT_PARAMS';
export const SET_LERNERID_ID = 'SET_LERNERID_ID';
export const SET_LANG = 'SET_LANG';
export const SET_LP_ID = 'SET_LP_ID';

// Login
export const IS_LOGIN_ERROR = 'IS_LOGIN_ERROR';
export const AUTHENTICATED = 'AUTHENTICATED';
export const R_URL = 'R_URL';
export const SET_IS_LP_AUTH_FAIL = 'SET_IS_LP_AUTH_FAIL';

// Content
export const GET_CONTENT_DETAILS = 'GET_CONTENT_DETAILS';
export const SET_CONTENT_DETAILS = 'SET_CONTENT_DETAILS';
export const SET_LAUNCHED_TYPE = 'SET_LAUNCHED_TYPE';
export const SET_LAUNCHED_URL = 'SET_LAUNCHED_URL';
export const SET_LAUNCHED_AICC_SESSION_ID = 'SET_LAUNCHED_AICC_SESSION_ID';
export const GET_LAUNCH_URL = 'GET_LAUNCH_URL';
export const SET_LAUNCHED_LCO_ID = 'SET_LAUNCHED_LCO_ID';
export const SET_LEARNER_ID = 'SET_LEARNER_ID';

export const SET_VIDEO_CAPTION = 'SET_VIDEO_CAPTION';
export const SET_AUDIO = 'SET_AUDIO';
export const SET_TYPE_VIDEO = 'SET_TYPE_VIDEO';

// Launch
export const SET_CURRENTLY_LAUNCHED = 'SET_CURRENTLY_LAUNCHED';
export const SET_LAST_LAUNCHED = 'SET_LAST_LAUNCHED';

// Error
export const SET_EXCEPTION = 'SET_EXCEPTION';
export const SET_LP_EXCEPTION = 'SET_LP_EXCEPTION';

// Loader
export const SET_LOADER = 'SET_LOADER';

// auth
export const LOGIN_ATTEMPT = 'LOGIN_ATTEMPT';
export const LOGIN_ERROR = 'LOGIN_ERROR';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const RESET_LOGIN_ERR = 'RESET_LOGIN_ERR';
export const VALIDATE_VOUCHER = 'VALIDATE_VOUCHER';
export const VOUCHER_ERROR = 'VOUCHER_ERROR';
export const VOUCHER_SUCCESS = 'VOUCHER_SUCCESS';
export const REFRESH_CAPTCHA = 'REFRESH_CAPTCHA';
export const RESET_CAPTCHA = 'RESET_CAPTCHA';
export const FORGOT_PWD = 'FORGOT_PWD';
export const FORGOT_SUCCESS = 'FORGOT_SUCCESS';
export const FORGOT_ERROR = 'FORGOT_ERROR';
export const RESET_FORGET_MSG = 'RESET_FORGET_MSG';

export const FETCH_HOME_DATA = 'FETCH_HOME_DATA';
export const SET_HOME_DATA = 'SET_HOME_DATA';
export const SET_HOME_CALL_ERROR = 'SET_HOME_CALL_ERROR';
export const SET_VUID = 'SET_VUID';
export const TOGGLE_MODAL = 'TOGGLE_MODAL';
export const SHOW_HELP = 'SHOW_HELP';
export const SUBMIT_CONTACT = 'SUBMIT_CONTACT';
export const UPDATE_CONTACT_STS = 'UPDATE_CONTACT_STS';
export const SET_AUTHTAB = 'SET_AUTHTAB';
export const SET_OPEN_PRIVACY_MODAL = 'SET_OPEN_PRIVACY_MODAL';
export const FETCH_PUBLIC_LIBRARIES = 'FETCH_PUBLIC_LIBRARIES';
export const FETCH_PUBLIC_LIBRARIES_SUCCESS = 'FETCH_PUBLIC_LIBRARIES_SUCCESS';
export const FETCH_PUBLIC_LIBRARIES_ERROR = 'FETCH_PUBLIC_LIBRARIES_ERROR';
